var map = {
	"./FormPage.js": "../node_modules/bundle-loader/index.js?lazy&name=[name]!../core-client/source/ui/pages/FormPage.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../core-client/source/ui/pages sync recursive ../node_modules/bundle-loader/index.js?lazy&name=[name]!./ Page\\.(j|t)sx?$";